import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";

import { readJobLogFile } from "../lib/readJobLogFile";
import { JOB_RESULTS_REFRESH_MS } from "../model/constants";

export const useJobLogFileContent = (path: string | undefined, enabled: boolean, shouldRefresh = false) => {
  const { t } = useTranslation();
  const errorMessage = t("Execution.transient.jobDetails.logsFailed");
  const canLoad = Boolean(path) && enabled;
  const query = useQuery(
    ["transientJobLogFileContent", path],
    () => {
      if (!path) throw new Error(errorMessage);
      return readJobLogFile({ errorMessage, path });
    },
    {
      enabled: canLoad,
      refetchInterval: shouldRefresh ? JOB_RESULTS_REFRESH_MS : false,
      refetchOnWindowFocus: shouldRefresh,
      retry: 2,
      retryDelay: JOB_RESULTS_REFRESH_MS,
      staleTime: shouldRefresh ? 0 : Infinity,
    }
  );

  return {
    error: query.isError ? errorMessage : null,
    isLoading: canLoad && query.isLoading,
    lines: query.data ?? [],
  };
};
